import { render } from "./redirection.vue?vue&type=template&id=745250ed&scoped=true"
import script from "./redirection.vue?vue&type=script&lang=js"
export * from "./redirection.vue?vue&type=script&lang=js"

import "./redirection.vue?vue&type=style&index=0&id=745250ed&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745250ed"]])

export default __exports__